import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, RouterModule } from '@angular/router';
import {
  TextColor,
  TextComponent,
  TextHeight,
  TextSize,
  TextSpacing,
  TextType,
  TextWeight,
} from '@app/components/text';
import {
  GroupChallengeTeamMemberV2,
  GroupChallengeTeamV2,
} from '@skyfit/core-data-library';

@Component({
  selector: 'app-challenge-leaderboard-card',
  standalone: true,
  imports: [RouterModule, TextComponent],
  templateUrl: './challenge-leaderboard-card.component.html',
  styleUrl: './challenge-leaderboard-card.component.scss',
})
export class ChallengeLeaderboardCardComponent implements OnInit {
  @Input() team!: GroupChallengeTeamV2;
  @Input() leaderboardHref?: string;
  subTeamlist: GroupChallengeTeamMemberV2[] = [];
  private readonly route = inject(ActivatedRoute);
  private readonly destroyRef = inject(DestroyRef);
  challengeId!: string;
  teamId!: string;
  leaderboardLink!: string;
  TextType = TextType;
  TextSize = TextSize;
  TextHeight = TextHeight;
  TextWeight = TextWeight;
  TextColor = TextColor;
  TextSpacing = TextSpacing;

  ngOnInit() {
    this.route.params
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(async (params) => {
        this.challengeId = params.id;
        this.teamId = (
          this.team.teamId ?? (this.team as { id?: string | number }).id
        )?.toString();
        this.leaderboardLink =
          this.leaderboardHref ??
          `/challenges/live/${this.challengeId}/leaderboard/${this.teamId}`;
        this.getSubTeams(this.team.members);
      });
  }

  getSubTeams(teams) {
    if (!teams) {
      return null;
    }
    const maxTeams = Math.min(teams.length, 3);
    this.subTeamlist = teams.slice(0, maxTeams);
  }

  getOrdinalSuffix(rank: number): string {
    if (rank % 100 >= 11 && rank % 100 <= 13) {
      return `${rank}th Place`;
    }

    const lastDigit = rank % 10;
    switch (lastDigit) {
      case 1:
        return `st Place`;
      case 2:
        return `nd Place`;
      case 3:
        return `rd Place`;
      default:
        return `th Place`;
    }
  }

  getParticipants(): string {
    const participantCount = this.team.members?.length ?? 0;
    const participantString =
      participantCount === 1 ? 'Participant' : 'Participants';
    return `${participantCount} ${participantString}`;
  }
}
